module.exports = __webpack_public_path__ + "img/avatar1.06b0a70e.svg";